import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  forwardRef,
  input,
  OnInit,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidationErrors
} from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UnifyOptionType } from '@cpd-app/core-module/models';
import { E164_REGEX } from '@cpd-app/core-module/constants/connect.const';

@Component({
  selector: 'cpd-premium-partner-input',
  templateUrl: './premium-partner-input.component.html',
  styleUrls: ['./premium-partner-input.component.scss'],
  imports: [FontAwesomeModule, ReactiveFormsModule],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PremiumPartnerInputComponent)
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => PremiumPartnerInputComponent)
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PremiumPartnerInputComponent
  implements OnInit, ControlValueAccessor
{
  private readonly onChanged = new Array<(value: string | string[]) => void>();
  private readonly onTouched = new Array<() => void>();
  protected readonly inputControl = new FormControl();

  protected readonly showTelError = signal<boolean>(false);

  public readonly placeholder = input<string>('');
  public readonly type = input<string>('');
  public readonly label = input<string>('');
  public readonly id = input<string>('');
  public readonly options = input<UnifyOptionType[]>([]);

  public constructor(private readonly destroyRef: DestroyRef) {}

  public ngOnInit(): void {
    this.inputControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (value) => {
          this.onChanged.forEach((it) => it(value));
        }
      });
  }

  public writeValue(obj: string | string[]): void {
    this.inputControl.setValue(obj);
  }

  public registerOnChange(fn: (value: string | string[]) => void): void {
    this.onChanged.push(fn);
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched.push(fn);
  }

  public validate({ value }: AbstractControl): ValidationErrors | null {
    if (!value) {
      return null;
    }

    this.showTelError.set(!E164_REGEX.test(value));

    return !E164_REGEX.test(value) && this.type() === 'tel'
      ? { e164: true }
      : null;
  }
}
